export let Role = /*#__PURE__*/function (Role) {
  Role["OWNER"] = "owner";
  Role["MANAGER"] = "manager";
  Role["CASHIER"] = "cashier";
  Role["INVENTORY"] = "inventory";
  Role["VIEWER"] = "viewer";
  return Role;
}({});
//# sourceMappingURL=role.enum.js.map